import { TFunction } from 'i18next'
import { toast } from 'react-toastify'
import { parseApiError } from 'shared/api/apiError'
import notifyServerError from 'shared/api/notifyServerError'
import { ConsignmentItemFormSaveResult } from './useConsignmentItemForm'

// eslint-disable-next-line import/prefer-default-export
export function notifyConsignmentItemSaveResult(
  result: ConsignmentItemFormSaveResult | null,
  t: TFunction,
) {
  if (!result) return

  if (!result.success) {
    const apiError = result.errorReason === 'unexpected' ? parseApiError(result.error) : null
    if (apiError?.reason === 'serverError' && apiError.traceId) {
      notifyServerError(apiError.traceId)
      return
    }
    toast.error(result.errorReason === 'validation'
      ? String(t('consignmentItem.validationError'))
      : String(t('consignmentItem.saveError')))
  } else {
    toast.success(String(t('consignmentItem.saveSuccess')))
  }
}
